import React from 'react';
import { DiscountPrice } from '@common/components/Price';

import { useTranslations } from '@lang';
import { Option } from 'shared-types/Common';
import { useIsWindowWiderThan } from '@common/hooks';
import { gridTheme } from '@utils/grid';
import { PriceWrapper, FromLabel } from './ItemPrice.styles';

export type ItemPriceProps = {
  price: Option;
  options?: Array<Option> | null;
  selectedOption?: Option;
};

/**
 * @deprecated Replaced with AddedToBasket/fulfilable for everything except retail products
 */
export const ItemPrice: React.FC<ItemPriceProps> = ({ price, options, selectedOption }) => {
  const { t } = useTranslations();
  const hasManyOptions = options && options?.length > 1;

  const isWiderViewport = useIsWindowWiderThan(gridTheme.breakpoints.lg);

  return isWiderViewport ? (
    <>
      {hasManyOptions && !selectedOption && (
        <>
          <FromLabel isSmall as="span">
            {t('product.from')}
          </FromLabel>
          <PriceWrapper>
            <DiscountPrice {...price} />
          </PriceWrapper>
        </>
      )}

      {(!hasManyOptions || selectedOption) && (
        <>
          <PriceWrapper>
            <DiscountPrice {...price} />
          </PriceWrapper>
        </>
      )}
    </>
  ) : null;
};
